import { LitElement, html } from '@hh/global.js'

class HHExtendWrapper extends LitElement {
  static properties = {}

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.isExtendActive =
      window.Extend &&
      window.ExtendShopify &&
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active === 'USD'

    this.isExtendProduct =
      window.meta.product && window.meta.product.vendor === 'Extend'

    this.checkExtendOffer().then((hasExtendOffer) => {
      if (this.isExtendActive && !this.isExtendProduct && hasExtendOffer) {
        this.initExtend()
        this.classList.remove('hidden')
      } else {
        this.classList.add('hidden')
      }
    })
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  initExtend() {
    const BUY_BUTTON_CLASS = '.js-extend-cart-button'

    this.nearestBuyButton = this.closest('form').querySelector(
      `${BUY_BUTTON_CLASS}, button[type=submit]`
    )

    this.buyButtonHandler = this.handleExtendButtonClick.bind(this)
    this.nearestBuyButton.addEventListener('click', this.buyButtonHandler, true)
  }

  async checkExtendOffer() {
    if (!this.isExtendActive) return
    try {
      
      const variantId = this.closest('form').id.value
    
      const findVariant = (variants = [], variantId) => {
        const variant = variants.find((item) => item.id.toString() === variantId)
        return variant
      }

      const productHandle = this.closest('form').handle.value
      const productMeta = window.meta.product
      let variant
      let productCategory
      let productPrice

      if (window.meta.page.pageType === 'product') {
        const windowHasVariant = findVariant(productMeta.variants, variantId)

        if (windowHasVariant) {
          variant = windowHasVariant
          productCategory = productMeta.type
        } else {
          const fetchedProduct = await this.fetchProductData(productHandle)
          const fetchedProductVariants = fetchedProduct.variants
          variant = findVariant(fetchedProductVariants, variantId)
          productCategory = fetchedProduct.product_type
        }

        productPrice = variant.price
      }
      
      const extendObj = await Extend.getOffer({
        referenceId: variantId,
        price: productPrice,
        category: productCategory
      })

      return Object.keys(extendObj?.product).length !== 0
    } catch (error) {
      console.error(error)
      return false
    }
  }

  handleExtendButtonClick(e) {
    e.preventDefault()
    e.stopImmediatePropagation()

    if (this.isExtendActive && !this.isExtendProduct) {
      this.extendModal(e)
    }
  }

  async fetchProductData(handle) {
    const data = await fetch(
      window.Shopify.routes.root + `products/${handle}.js`
    )
      .then((response) => response.json())
      .then((product) => product)
    return data
  }

  async extendModal(e) {
    this.nearestBuyButton.removeEventListener(
      'click',
      this.buyButtonHandler,
      true
    )

    const findVariant = (variants = [], variantId) => {
      const variant = variants.find((item) => item.id.toString() === variantId)
      return variant
    }

    const productHandle = this.closest('form').handle.value
    const variantId = this.closest('form').id.value
    const productMeta = window.meta.product
    let variant
    let productCategory
    let productPrice

    if (window.meta.page.pageType === 'product') {
      const windowHasVariant = findVariant(productMeta.variants, variantId)

      if (windowHasVariant) {
        variant = windowHasVariant
        productCategory = productMeta.type
      } else {
        const fetchedProduct = await this.fetchProductData(productHandle)
        const fetchedProductVariants = fetchedProduct.variants
        variant = findVariant(fetchedProductVariants, variantId)
        productCategory = fetchedProduct.product_type
      }

      productPrice = variant.price
    }

    const reInitBuyButtonEvent = () => {
      this.nearestBuyButton.addEventListener(
        'click',
        this.buyButtonHandler,
        true
      )
    }

    Extend.modal.open({
      referenceId: variantId,
      price: productPrice,
      category: productCategory,
      onClose: (plan, product) => {
        if (plan && product) {
          ExtendShopify.addPlanToCart(
            {
              plan: plan,
              product: product,
              quantity: 1,
            },
            (err) => {
              if (err) return
              this.nearestBuyButton.click()
              reInitBuyButtonEvent()
            }
          )
        } else {
          const targetButton = e?.target?.tagName === 'BUTTON'
            ? e.target
            : e?.target?.closest('button')

          if (targetButton === this.nearestBuyButton) {
            this.nearestBuyButton.click()
          }
          reInitBuyButtonEvent()
        }
      },
    })
  }

  render() {
    return html`<slot @click=${this.handleExtendButtonClick}></slot>`
  }
}

window.addEventListener("load", () => {
  customElements.define('hh-extend-wrapper', HHExtendWrapper)
});
